import { UserData } from 'models';
import { readFromStorage, writeToStorage } from './storage';

const SURVEY_HAS_BEEN_SUBMITTED = 'surveyHasBeenSubmitted';
export const hasSurveyBeenSubmittedByUser = (user: UserData) => {
  const submissions = readFromStorage(SURVEY_HAS_BEEN_SUBMITTED);
  return !!submissions && !!user && !!submissions[user.code];
};

export const setSurveyHasBeenSubmittedByUser = (user: UserData) => {
  const submissions = readFromStorage(SURVEY_HAS_BEEN_SUBMITTED) || {};
  submissions[user.code] = true;
  writeToStorage(SURVEY_HAS_BEEN_SUBMITTED, submissions);
};
